module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/happypack/loader.js?id=jsx!./BrowseMenuView.jsx"));
	}, "BrowseMenu");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=BrowseMenu!./src/pages/bundle-appResource-mgmt/BrowseMenu/BrowseMenuView.jsx
// module id = ./node_modules/bundle-loader/index.js?lazy&name=BrowseMenu!./src/pages/bundle-appResource-mgmt/BrowseMenu/BrowseMenuView.jsx
// module chunks = 43